//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import times from "../../../src/api/common.js"
import empty from '@/components/empty/index.vue'
export default {
  components: {
    empty
  },
    data(){
        return {
          photoUrl: this.$store.state.userInfo.headphoto,
            message: '暂无订单数据',
            docid:"",
            item:{},
            datalist:"",
            skillname:[],
            counts:"",
            doclist:{},
            patlist:{},
            ordermaintellinfo:{},
            orderprescriptioninfos:[],
            oredermessage:{},
        }
    },
    methods:{

        query(){
            var _this  = this;
            this.$doRequest(
                        "/api/Inquiry/orderDetails",{
                            getOrder:1,
                             orderID:this.$route.query.id, //下边prescr屏蔽
//                            prescriptionOrderId:"202006021047368409a4bbed9ccd0",
                            getDoctor:1,
                            getPatient:1,
                            isaction:1,
                            isInterrogationsingle:1,
                            getPrescriptionOrder:1,
                            }
                    ,res => {
                        this.doclist = res.patient;
//                        this.patlist.patientname = res.patient.patientname;
//                        this.patlist.age = res.ordermaintellinfo.age;
//                        this.patlist.sex = res.patient.sex;
//                        this.patlist.height = res.ordermaintellinfo.height;
//                        this.patlist.weight = res.ordermaintellinfo.weight;
//                        this.ordermaintellinfo = res.ordermaintellinfo;
                        this.oredermessage=res.orderprescriptioninfos[0];
                for(let j=0;j<res.orderprescriptioninfos.length;j++){
                for(let i=0;i<res.orderprescriptioninfos[j].reOrderprescriptioninfo.length;i++){
                  res.orderprescriptioninfos[j].reOrderprescriptioninfo[i].createtime = new Date(parseInt(res.orderprescriptioninfos[j].reOrderprescriptioninfo[i].createtime)).toLocaleString().replace(/:\d{1,2}$/,' ');
                }
                }
//                this.orderprescriptioninfos = res.orderprescriptioninfos[0].reOrderprescriptioninfo;
                this.orderprescriptioninfos = res.orderprescriptioninfos;
                    });
        }
    },
    //生命周期之挂载完成
    mounted: function() {

    },
    //生命周期之创建完成
    created:
      function() {
        document.title = '病历详情';
        this.$isLogin(window.location.search.substr(1), this.query);

    },
    //生命周期之更新
    updated: function () {

    },
    //生命周期之销毁
    destroyed: function () {

    }
}



// WEBPACK FOOTER //
// ./src/views/case/index.vue